/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import VerticalSplit from '../components/Common/VerticalSplit/VerticalSplit';
import DuesEstimator from '../components/DuesEstimator/DuesEstimator';
import { ModalContext } from '../contexts/ModalContext';
import WithBackdropContext from '../hocs/WithBackdropContext/WithBackdropContext';
import WithLoading from '../hocs/WithLoading/WithLoading';
import { useEntities } from '../hooks/use-entities';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

const VerticalSplitWithLoading = WithLoading(VerticalSplit);
const DuesEstimatorWithModal = WithBackdropContext('modal', ModalContext, DuesEstimator);

const ScreensDuesEstimator = (): JSX.Element | null => {
    const { loading, error, fetchData, countries, careerTypes } = useEntities();
    const classes = makeStyles({
        caption: {
            fontStyle: 'italic',
            marginBottom: '20px',
        },
    })();

    const caption = (
        <div className={classes.caption}>
            <Typography variant="caption">
                The dues calculator helps new or reinstating members estimate their national, state, and local chapter
                membership dues before joining, based on current promotions. Please note, this tool is not for current
                or renewing members. If you&apos;re already a member and need to renew, you can do so at{' '}
                <a href="https://renew.aia.org">renew.aia.org</a>.
            </Typography>
        </div>
    );
    useEffect(() => {
        if (!(countries && careerTypes)) {
            fetchData();
        }
    }, []);

    return (
        <VerticalSplitWithLoading
            loading={loading}
            error={error}
            title="Estimate membership dues"
            left={<DuesEstimatorWithModal />}
            right={<></>}
            caption={caption}
        />
    );
};

export default ScreensDuesEstimator;
